var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVippsLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.5 48.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ff5b24;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.48.96l8.19,23.94L25.87.96h9.48l-14.14,35.5h-7.07L0,.96h9.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.55,30.85c5.94,0,9.32-2.89,12.53-7.07,1.77-2.25,4.02-2.73,5.62-1.45s1.77,3.69,0,5.94c-4.66,6.1-10.6,9.8-18.15,9.8-8.19,0-15.42-4.5-20.4-12.37-1.45-2.09-1.12-4.34.48-5.46,1.61-1.12,4.02-.64,5.46,1.61,3.53,5.3,8.35,9,14.46,9ZM67.63,11.09c0,2.89-2.25,4.82-4.82,4.82s-4.82-1.93-4.82-4.82,2.25-4.82,4.82-4.82,4.82,2.09,4.82,4.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.29.96v4.82c2.41-3.37,6.1-5.78,11.57-5.78,6.91,0,14.94,5.78,14.94,18.15,0,13.01-7.71,19.28-15.74,19.28-4.18,0-8.03-1.61-10.92-5.62v17.03h-8.68V.96h8.84ZM90.29,18.64c0,7.23,4.18,11.08,8.84,11.08s9-3.53,9-11.08-4.5-10.92-9-10.92-8.84,3.37-8.84,10.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.06.96v4.82c2.41-3.37,6.11-5.78,11.57-5.78,6.91,0,14.94,5.78,14.94,18.15,0,13.01-7.71,19.28-15.74,19.28-4.18,0-8.03-1.61-10.92-5.62v17.03h-8.68V.96h8.84ZM132.06,18.64c0,7.23,4.18,11.08,8.84,11.08s9-3.53,9-11.08-4.5-10.92-9-10.92-8.84,3.37-8.84,10.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.04,0c7.23,0,12.37,3.37,14.62,11.73l-7.87,1.29c-.16-4.18-2.73-5.62-6.59-5.62-2.89,0-5.14,1.29-5.14,3.37,0,1.61,1.12,3.21,4.5,3.86l5.94,1.12c5.78,1.12,9,4.98,9,10.12,0,7.71-6.91,11.57-13.5,11.57-6.91,0-14.62-3.53-15.74-12.21l7.87-1.29c.48,4.5,3.21,6.1,7.71,6.1,3.37,0,5.62-1.29,5.62-3.37,0-1.93-1.13-3.37-4.82-4.02l-5.46-.96c-5.78-1.12-9.32-5.14-9.32-10.28.16-8.03,7.39-11.41,13.17-11.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVippsLogoText);
export default __webpack_public_path__ + "static/media/vipps-logo-text.015812fb9fba60a8b66e6b0fd0b45d51.svg";
export { ForwardRef as ReactComponent };